import React, { ReactElement, ReactNode, createContext } from "react"

import { LCTOnlyDatasets } from "../../../../../../constants/enums"
import { AppError } from "../../../../../../errors/errorProcessors"
import { IDeviceFormContextValue } from "../../../../types/providerTypes"
import AmendHpDeviceProvider from "../../../hp/providers/baseProviders/amendHpDeviceProvider"
import { HpDeviceFormData } from "../../../types/providerTypes"

export const AmendAcuDeviceContext = createContext(
    {} as IDeviceFormContextValue<HpDeviceFormData>
)

type AmendAcuDeviceProviderProps = {
    formData: HpDeviceFormData
    setFormData: React.Dispatch<React.SetStateAction<HpDeviceFormData>>
    formDataIsLoading: boolean
    systemReference: string
    formDataError?: AppError
    attachmentUUID?: string
    children: ReactNode
}

/**
 * Thin wrapper around AmendHpDeviceProvider — delegates all logic,
 * only overrides the dataset (ACU) and context.
 */
const AmendAcuDeviceProvider = ({
    formData,
    setFormData,
    formDataIsLoading,
    formDataError,
    systemReference,
    attachmentUUID,
    children,
}: AmendAcuDeviceProviderProps): ReactElement => (
    <AmendHpDeviceProvider
        formData={formData}
        setFormData={setFormData}
        formDataIsLoading={formDataIsLoading}
        formDataError={formDataError}
        systemReference={systemReference}
        attachmentUUID={attachmentUUID}
        dataset={LCTOnlyDatasets.ACU}
        deviceContext={AmendAcuDeviceContext}
    >
        {children}
    </AmendHpDeviceProvider>
)

AmendAcuDeviceProvider.defaultProps = {
    formDataError: undefined,
    attachmentUUID: undefined,
}

export default AmendAcuDeviceProvider
